import React from "react";
import { ArrowNext, ArrowNextCretor, ArrowPrev, ArrowPrevCretor } from "shared/Slider/styled";
import { Icon } from "components/SvgIcons";

export const settingsCollections = {
  dots: false,
  infinite: false,
  lazyLoad: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 2,
  variableWidth: true,
  nextArrow: (
    <ArrowNext>
      <Icon icon="swipe_next" />
    </ArrowNext>
  ),
  prevArrow: (
    <ArrowPrev>
      <Icon icon="swipe_next" />
    </ArrowPrev>
  ),
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 2,
        arrows: false,
      },
    },
    {
      breakpoint: 720,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: false,
      },
    },
  ],
};

export const settingsCreator = {
  dots: true,
  lazyLoad: false,
  preLoad: 4,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  variableWidth: true,
  nextArrow: (
    <ArrowNextCretor>
      <Icon icon="swipe_next" />
    </ArrowNextCretor>
  ),
  prevArrow: (
    <ArrowPrevCretor>
      <Icon icon="swipe_next" />
    </ArrowPrevCretor>
  ),
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
      },
    },
    {
      breakpoint: 475,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
      },
    },
  ],
};

export const settingsRecipes = {
  dots: false,
  lazyLoad: false,
  preLoad: 3,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 2,
  draggable: false,
  variableWidth: true,
  nextArrow: (
    <ArrowNext>
      <Icon icon="swipe_next" />
    </ArrowNext>
  ),
  prevArrow: (
    <ArrowPrev>
      <Icon icon="swipe_next" />
    </ArrowPrev>
  ),
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
        arrows: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
      },
    },
    {
      breakpoint: 475,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
      },
    },
  ],
};

export const settingsSpot = {
  dots: true,
  preLoad: 1,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: (
    <ArrowNext>
      <Icon icon="swipe_next" />
    </ArrowNext>
  ),
  prevArrow: (
    <ArrowPrev>
      <Icon icon="swipe_next" />
    </ArrowPrev>
  ),
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        arrows: false,
      },
    },
  ],
};

export const settingsCelebrity = {
  dots: false,
  preLoad: 1,
  infinite: false,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  variableWidth: true,
  nextArrow: (
    <ArrowNext>
      <Icon icon="swipe_next" />
    </ArrowNext>
  ),
  prevArrow: (
    <ArrowPrev>
      <Icon icon="swipe_next" />
    </ArrowPrev>
  ),
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        arrows: false,
      },
    },
  ],
};

export const settingsCelebrityMob = {
  ...settingsCelebrity,
  dots: true,
  slidesToShow: 1,
};
